import * as csstree from 'css-tree';
import { stringToCode, mergeObject, sortObjectByKey, kebabToCamelCase } from './utils';

export const revertStyles = (dom) => {
    let result = {};
    const elements = dom.querySelectorAll('head>style[media=all], head>style[media=screen]');

    for (let e in elements) {
        let cssContent = elements[e].innerHTML;

        if (typeof cssContent !== 'undefined') {
            let ast = csstree.parse(cssContent, {
                context: 'stylesheet',
                parseAtrulePrelude: false,
                parseRulePrelude: false,
                parseValue: false,
            });

            const state = {
                was: 'Block',
                except: 'Rule',
                define: false,
                activeKeys: [],
            };

            let nodeString = '';

            // Additional params
            // , item, list
            csstree.walk(ast, (node) => {
                nodeString = csstree.generate(node);
                console.log(
                    `✅ Style node generated: Was: ${state.was}, type: ${node.type}, except: ${state.except}`,
                );

                if (state.was === 'Block' && node.type === 'Rule' && state.except === 'Rule') {
                    state.except = 'Raw';
                    console.log(`----- 🚀 Look for ${node.type}, was: ${state.was}`);
                    state.was = 'Rule';
                }

                if (state.was === 'Rule' && node.type === 'Raw' && state.except === 'Raw') {
                    state.except = 'Block';
                    state.activeKeys = [];
                    let selectors = extractSelectors(nodeString);
                    for (let sel in selectors) {
                        let selectorKey = stringToCode(selectors[sel]);
                        if (selectorKey.length > 0 && selectorKey !== ' ') {
                            console.log(`---------- 📟 Setting up new selector 🚥${selectorKey}🚥`);
                            state.activeKeys.push([selectors[sel], selectorKey]);
                            result = keySetModel(result, selectors[sel], selectorKey);
                        }
                    }
                    console.log(
                        `----- 🚀 Look for ${node.type} AS KEY SET, SELECTOR: ${nodeString}`,
                    );
                    state.was = 'Raw';
                }

                if (state.was === 'Raw' && node.type === 'Block' && state.except === 'Block') {
                    state.except = 'Rule';
                    console.log(
                        `----- 🚀 Look for ${node.type} AS VALUE, SELECTOR VALUE: ${nodeString}`,
                    );
                    for (let ak in state.activeKeys) {
                        let activeSelector = state.activeKeys[ak][0];
                        let activeSelectorKey = state.activeKeys[ak][1];
                        result = keySetModel(result, activeSelector, activeSelectorKey, nodeString);
                    }
                    state.was = 'Block';
                }
            });
        }
    }

    return result;
};

// Setup CSS selector declarations
export const keySetModel = (result, selector, selectorKey, raw = '{}') => {
    let rulesCSS = declarationRawToObject(raw).css;
    let rulesJS = declarationRawToObject(raw).js;

    if (!Object.keys(result).includes(selectorKey)) {
        result[selectorKey] = {
            selectorKey: selectorKey,
            selector: selector,
            declaration: rulesCSS,
            declarationJs: rulesJS,
        };
    } else {
        result[selectorKey].declaration = sortObjectByKey(
            mergeObject(rulesCSS, result[selectorKey].declaration),
        );
        result[selectorKey].declarationJs = sortObjectByKey(
            mergeObject(rulesJS, result[selectorKey].declarationJs),
        );
    }

    return result;
};

export const declarationRawToObject = (raw) => {
    let starts = raw.substring(0, 1),
        ends = raw.substring(raw.length - 1),
        result = {
            css: {},
            js: {},
        };

    if (raw.length > 2 && starts === '{' && ends === '}') {
        raw = raw
            .trim()
            .substring(1)
            .substring(0, raw.length - 2);
        let rows = raw.split(';');
        for (let r in rows) {
            let pair = rows[r].split(':');
            result.css[pair[0]] = pair.length === 2 ? pair[1] : '';
            result.js[kebabToCamelCase(pair[0])] = pair.length === 2 ? pair[1] : '';
        }
    }
    console.log(`RESULT object: ${raw.length}`, result);
    return result;
};

export const extractSelectors = (str) => {
    return str.split(',').map((e) => e.trim());
};

export const assemblyStyles = (DOM, declaration) => {
    console.log('DOM assembly', DOM);
    for (let index in declaration) {
        let group = declaration[index];
        let nodeList = DOM.querySelectorAll(group.selector);

        if (
            typeof nodeList === 'object' &&
            nodeList.length > 0 &&
            Object.keys(group.declarationJs).length > 0
        ) {
            console.log(group.selector, group.declarationJs);
            try {
                for (let n in nodeList) {
                    for (let rule in group.declarationJs) {
                        let value = group.declarationJs[rule];
                        console.log('ASSIGN', group.selector, rule, value);
                        nodeList[n].style[rule] = value;
                    }
                }
            } catch (error) {
                console.error('ERROR', group.selector, typeof nodeList, nodeList.length, 'error');
            }
        }
    }

    return DOM;
};

export const detectHTMLComments = (html) => {
    const regexp = /(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g;
    return html.match(regexp);
};

export const removeHTMLComments = (html) => {
    const regexp = /(<!--.*?-->)|(<!--[\S\s]+?-->)|(<!--[\S\s]*?$)/g;
    return html.replace(regexp, '');
};

export const detectDoubleCurlyBraces = (html) => {
    const regexp = /(\{\{.*?\}\})|(\{\{[\S\s]+?\}\})|(\{\{[\S\s]*?$)/g;
    let r = html.match(regexp);
    for (let i in r) {
        r[i] = r[i].replace('{{', '').replace('}}', '');
    }
    return r;
};

export const replaceDoubleCurlyBraces = (html, data = {}) => {
    const regexp = /(\{\{.*?\}\})|(\{\{[\S\s]+?\}\})|(\{\{[\S\s]*?$)/g;
    let r = html.match(regexp);
    for (let i in r) {
        //if (r[i])
        r[i] = r[i].replace(data[i]);
    }
    return html.replace(regexp, '');
};

export const removeEmptyLines = (str) => {
    const regexp = /^\s*$(?:\r\n?|\n)/gm;
    return str.replace(regexp, '\n');
};

export const supportDOMParser = () => {
    if (!window.DOMParser) {
        return false;
    }

    const parser = new DOMParser();

    try {
        parser.parseFromString('x', 'text/html');
    } catch (err) {
        return false;
    }
    return true;
};

/**
 * Convert a string template string into HTML DOM nodes
 * @param  {String} str The template string
 * @return {Node}       The template HTML
 */
export const stringToHTMLDOM = (str, forceLegacy = false) => {
    // If DOMParser is supported, use it
    if (forceLegacy === false && supportDOMParser()) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(str, 'text/html');
        return doc;
    }

    // Otherwise, fallback to old-school method
    const dom = document.createElement('html');
    dom.innerHTML = str;
    return dom;
};

export const useDOM = () => {
    return {
        revertStyles: revertStyles,
        assemblyStyles: assemblyStyles,
        detectHTMLComments: detectHTMLComments,
        removeHTMLComments: removeHTMLComments,
        detectDoubleCurlyBraces: detectDoubleCurlyBraces,
        replaceDoubleCurlyBraces: replaceDoubleCurlyBraces,
        removeEmptyLines: removeEmptyLines,
        supportDOMParser: supportDOMParser,
        stringToHTMLDOM: stringToHTMLDOM,
    };
};

export default useDOM;
